import React from 'react';
import { Provider } from 'react-redux';
import { CssBaseline, ThemeProvider } from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import theme from '../../../../../global/react-mui/theme';
import store from './store';
import DateFnsUtils from '@date-io/date-fns';
import HeatingFormApp from './views/Main';


export default function Root(): JSX.Element {
	return (
		<MuiPickersUtilsProvider utils={DateFnsUtils}>
			<ThemeProvider theme={theme}>
				<CssBaseline />
				<Provider store={store}>
					<HeatingFormApp />
				</Provider>
			</ThemeProvider>
		</MuiPickersUtilsProvider>
	);
}
